import { CircularProgress, Divider, Typography } from "@material-ui/core";
import React from "react";
import { ReservationIncomeItemData } from "../../types/reservation.types";
import { ReservationIncomeItem } from "./ReservationIncomeItem";
import useStyles from "./ReservationsIncomeStyles";

interface ReservationsIncomeProps {
  items: ReservationIncomeItemData[];
  total: number;
  loading?: boolean;
  error?: string | null;
}

export const ReservationsIncome = ({ items, total, loading, error }: ReservationsIncomeProps) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <Typography className={classes.title}>Ingresos de hoy</Typography>
        {!loading && !error && <Typography className={classes.count}>{total} escaneos</Typography>}
      </div>
      <Divider />

      {loading && (
        <div className={classes.state}>
          <CircularProgress size={24} />
        </div>
      )}

      {!loading && error && (
        <div className={classes.state}>
          <Typography className={classes.stateText}>{error}</Typography>
        </div>
      )}

      {!loading && !error && items.length === 0 && (
        <div className={classes.state}>
          <Typography className={classes.stateText}>Todavía no hay ingresos hoy.</Typography>
        </div>
      )}

      {!loading && !error && items.length > 0 && (
        <div className={classes.list}>
          {items.map((item, index) => (
            <React.Fragment key={item.id}>
              {index > 0 && <Divider />}
              <ReservationIncomeItem
                name={item.name}
                initials={item.initials}
                time={item.time}
                type={item.type}
                option={item.option}
                description={item.description}
              />
            </React.Fragment>
          ))}
        </div>
      )}
    </div>
  );
};
